import React, { useState, useEffect } from "react";
import { Layout, Drawer } from "antd";
import NavigationBar from "./NavigationBar";
import Logo from "./Logo";
import Routes from "./Routes";
import SideMenu from "./SideMenu";
import "./styles.css";

const { Header, Content, Sider } = Layout;

const BaseLayout = (props) => {
  const {
    match: { url: baseUrl },
  } = props;

  // Collapsible sidebar state; default open. CSS handles responsive defaults.
  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 1024) {
        setCollapsed(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sider width is controlled via Sider props (width/collapsedWidth)
  // Width is now handled via CSS classes to avoid layout thrash

  // Responsive breakpoint handling
  // No resize effect needed

  // Handlers are wired per viewport-specific header sections (CSS controls visibility)
  const toggleCollapsed = () => setCollapsed((v) => !v);
  const openMobileDrawer = () => setMobileDrawerVisible(true);

  // Filter modal bottom sheet on Mobile & Tablet screens
  const [isMobileTabletFilterModalOpen, setIsMobileTabletFilterModalOpen] = useState(false);
  
  // Toggle handled inline where needed

  const handleMobileDrawerClose = () => {
    setMobileDrawerVisible(false);
  };

  return (
  <Layout className="base-layout">
      {/* Sidebar (CSS hides it on mobile) */}
  <Sider
        width={250}
        collapsedWidth={60}
        // collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        className="base-layout-sider"
      >
        <Header className="base-layout-sider__header">
          <Logo
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            isMobile={false}
            isTablet={false}
            onMobileMenuToggle={toggleCollapsed}
            showLogo={!collapsed}
          />
        </Header>
        <SideMenu baseUrl={baseUrl} collapsed={collapsed} isMobile={false} />
      </Sider>

      {/* Mobile Drawer */}
      <Drawer
        title={
          <div className="mobile-drawer-header">
            <div className="logo__title">PRST</div>
          </div>
        }
        placement="left"
        onClose={handleMobileDrawerClose}
        visible={mobileDrawerVisible}
        width={250}
        className="mobile-sidebar-drawer"
        closeIcon={null}
        extra={
          <div
            className="drawer-close-button"
            onClick={handleMobileDrawerClose}
          >
            ×
          </div>
        }
      >
        <SideMenu
          baseUrl={baseUrl}
          collapsed={false}
          isMobile={true}
          onMenuItemClick={handleMobileDrawerClose}
        />
      </Drawer>

      <Layout
        className={`base-layout__outer ${collapsed ? 'collapsed' : 'expanded'}`}
      >
        <Header className="base-layout-header">
          {/* Mobile layout: Two rows */}
          <div className="mobile-header-container">
            {/* Row 1: Logo and Hamburger */}
            <div className="mobile-header-row-1">
              <Logo
                collapsed={false}
                setCollapsed={setCollapsed}
                isMobile={true}
                isTablet={false}
                onMobileMenuToggle={openMobileDrawer}
                showLogo={true}
                showHamburger={true}
                showFilterButton={false}
              />
            </div>
            {/* Row 2: Filter Button Full Width */}
            <div className="mobile-header-row-2">
              <Logo
                collapsed={false}
                setCollapsed={setCollapsed}
                isMobile={true}
                isTablet={false}
                onMobileMenuToggle={openMobileDrawer}
                showLogo={false}
                showHamburger={false}
                showFilterButton={true}
                openFilterModal={() => setIsMobileTabletFilterModalOpen(true)}
                isFullWidthFilter={true}
              />
            </div>
          </div>

          {/* Tablet layout: One row with centered filter button */}
          <div className="tablet-header-menu">
            <Logo
              collapsed={false}
              setCollapsed={setCollapsed}
              showLogo={false}
              showHamburger={false}
              isMobile={false}
              isTablet={true}
              onMobileMenuToggle={() => setCollapsed((v) => !v)}
              showFilterButton={true}
              openFilterModal={() => setIsMobileTabletFilterModalOpen(true)}
            />
          </div>

          {/* Desktop Navigation Bar - visible via CSS only on desktop */}
          <div className="desktop-header-menu">
            <NavigationBar 
              collapsed={collapsed} 
              isMobileTabletFilterModalOpen={isMobileTabletFilterModalOpen}
              closeMobileTabletFilterModal={() => setIsMobileTabletFilterModalOpen(false)}
            />
          </div>
        </Header>

        <Layout className="base-layout__content-layout">
          <Content className="base-layout__content">
            <Routes />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default BaseLayout;
